import { useMemo } from 'react';

import { useHookResult } from 'pages/funnel/storage/hooks';
import { useAnalyticsService } from 'services/AnalyticsService';
import { EXPERIMENTS } from 'utils/constants/experiment-configs';
import { useExperiment } from 'utils/customHooks/useExperiment';

const NEW_CHECKOUT_IDENTIFIER = { type: 'checkout-redesign' };

export const useCheckoutRedesignAnalyticsData = () => {
  const analyticsService = useAnalyticsService();
  const { variant } = useExperiment({
    experiment: EXPERIMENTS.CHECKOUT_REDESIGN,
    skipTracking: true,
  });

  const combinedAnalyticsData = useMemo(() => ({
    ...(analyticsService.analyticsData || {}),
    content: {
      ...NEW_CHECKOUT_IDENTIFIER,
      checkout_redesign_variant: variant,
    },
  }), [analyticsService.analyticsData, variant]);

  return useHookResult(combinedAnalyticsData) as typeof combinedAnalyticsData;
};
